import React, { FC, createContext, useContext } from 'react';
import CompanyService from 'services/CompanyService/company.service';

type UserContextType = {
  companyImageUrl: string | undefined;
  fetchCompanyImage: () => void;
  setCompanyImageUrl: (url: string | undefined) => void;
};

export const UserContext = createContext<UserContextType>({
  companyImageUrl: '',
  fetchCompanyImage: () => {},
  setCompanyImageUrl: () => {},
});

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserContextProvider');
  }
  return context;
};

export const UserContextProvider: FC = ({ children }) => {
  const { fetchCompanyImage, companyImageUrl, setCompanyImageUrl } =
    CompanyService();

  return (
    <UserContext.Provider
      value={{
        companyImageUrl,
        fetchCompanyImage,
        setCompanyImageUrl,
      }}>
      {children}
    </UserContext.Provider>
  );
};
